module.exports = '3.13.0';



// WEBPACK FOOTER //
// ./src/version.js